export default __webpack_public_path__ + "static/media/loader.ebaada9a.gif";